import type { Components } from "@mui/material/styles";
import { getContrastColor } from "./utils";

export const MuiCheckbox: Components["MuiCheckbox"] = {
  styleOverrides: {
    root: {
      zIndex: 1,
      "&::before": {
        content: "''",
        position: "absolute",
        display: "inline-block",
        borderRadius: "3px",
        zIndex: -1,
      },
      i: {
        color: "var(--color-secondary-light)",
      },
      // "&.Mui-checked": {
      //   "&::before": {
      //     width: "18px",
      //     height: "18px",
      //     background: getContrastColor(),
      //   },
      // }
    },
  },
};
